module.exports = __webpack_public_path__ + "static/img/Frame 1312318390@2x.f2db0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame 1312318390@2x.png
// module id = qSwv
// module chunks = 1